import assetsData from './subdomainLogos.json';

export const getSubdomainOverride = () => {
  const hostname = window.location.hostname;
  const subdomain = hostname === 'localhost' || hostname === '127.0.0.1' ? 'localhost' : hostname.split('.')[0];

  const assets = (assetsData as any)[subdomain];

  if (!assets) return null;

  return {
    title: assets.title,
    login: {
      logo: assets.logo
    },
    theme: {
      title: assets.title,
      logo: assets.logo,
      poweredBy: assets.poweredBy,
      shortLogo: assets.shortLogo || assets.logo,
      ...(assets.favicon && { favicon: assets.favicon }),

      ...(assets.primary && { primary: assets.primary }),
      ...(assets.secondary && { secondary: assets.secondary })
    }
  };
};
